import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
export const exportRequest = createAsyncThunk<string, {fileName:string, format: string, formData: FormData }>('export/request',
    async ({ fileName, format, formData }: { fileName: string; format: string; formData: FormData }) => {
        const response = await axiosInstance.post(`/rest/export/request/${format}/${fileName}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        if (response.data.uid) {
            let status =  await axiosInstance.get(`/rest/export/status?uid=${response.data.uid}`);

            if(status.data.resultFill === 'None') { 
                // Call this API until the status is 'Full'
                do {
                    await delay(1000); // Wait for 1 second
                    status = await axiosInstance.get(`/rest/export/status?uid=${response.data.uid}`);
                    if (status.data.resultFill === 'Error') {
                        return null; // Return null if an error occurs
                    }
                } while (status.data.resultFill !== 'Full');          
            }
            if(status.data.resultFill === 'Error') { 
                return null;
            }

            // Return file URL if the status is 'Full'
            if(status.data.resultFill === 'Full' && status.data.uid) {
                return `${axiosInstance.defaults.baseURL}/rest/export/file?uid=${status.data.uid}`;
            }
        }
        return response.data;
    }
);

export const exportFile = (uid: string) => {
    return `${axiosInstance.defaults.baseURL}/rest/export/file?uid=${uid}`;
};

const initialState: any = {
    fileUrl: null,
    loading: false,
    error: null,
};

const exportSlice = createSlice({
    name: 'export',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(exportRequest.pending, (state) => {
                state.exportRequestLoading = true;
            })
            .addCase(exportRequest.fulfilled, (state, action) => {
                state.exportRequestLoading = false;
                state.fileUrl = action.payload; 
            })
            .addCase(exportRequest.rejected, (state, action) => {
                state.exportRequestLoading = false;
                state.error = action.error.message || null; 
            });
    },
});

export default exportSlice.reducer;
